import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CommonService } from '../../../core/services/common.service';
import { Loader } from '../../../../shared/components/loader/loader';
import { CustomPaginationComponent } from '../../../../shared/components/custom-pagination/custom-pagination.component';
import { FilterSharedDropdown } from '../../../../shared/components/filter-shared-dropdown/filter-shared-dropdown';
import { ContentMapperService } from '../../../core/services/content-mapper-service';
import { ToastrService } from 'ngx-toastr';
import { NoDataComponent } from '../../../../shared/components/no-data/no-data.component';
import { CreateSegment } from '../create-segment/create-segment';
import { segment_endpoint } from '../../../data/api-endpoint/segment-endpoint';
import { UpperCasePipe } from '../../../../shared/pipes/upper-case-pipe';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-segment-listing',
  imports: [Loader, CustomPaginationComponent,
    FormsModule, NoDataComponent,CommonModule,CreateSegment,FilterSharedDropdown,UpperCasePipe],
  templateUrl: './segment-listing.html',
  styleUrl: './segment-listing.scss'
})
export class SegmentListing {


  searchIcon = 'assets/img/search.svg';
  filterIcon = 'assets/img/filter.png';
  plusIcon = 'assets/img/plus.svg';
  editIcon = 'assets/img/edit.png';
  deleteIcon = 'assets/img/bin.png';
  upIcon = 'assets/img/up.png';
  downIcon = 'assets/img/down.png';


  sortingKey:string = '';
  sortingValue:string = '';
  debounceTimeout!:any

  activeDropdownIndex: number = -1;

  loader:boolean = false;
  toggleFilter:boolean = false;
  noData: boolean = false;
  isAdmin:boolean = false;
  totalCount: number = 0;

  userPermissions: any[] = [];



  filter: any = {
    page: 1,
    limit: 10,
    search: '',
    sortKey: '',
    sortValue: '',
    segment_type: [],
    status:[],
    providerElementIds:[],
    partnerIds:[]
  }

  segmentList:any = [];

  statusList:Record<string,string>[] = [];
  segmentTypeList:Record<string,string>[] = [];
  partnerList:string[] = [];
  providerElementList:string[] = [];

  userSubscription: Subscription = new Subscription();
  

  constructor(private _router: Router, private _commonService: CommonService,
    private _contentMapper: ContentMapperService, private toastr: ToastrService){

  }

  ngOnInit(): void {
    this.fetchFilter()
    this.getSegmentList('ngOnInit')

    document.addEventListener('click', (event) => {
      const target = event.target as HTMLElement;
      if (!target.closest('.action-dropdown')) {
        this.activeDropdownIndex = -1;
      }
    });

    this.userSubscription = this._commonService.getUserDetail().subscribe((user: any) => {
      this.isAdmin = user.role === 'admin';
      this.userPermissions = user.permissions_ids;
    })
  }


  openFilter() {
    this.toggleFilter = !this.toggleFilter;
  }

  onSearch(e: Event) {
    const value = (e.target as HTMLInputElement).value;
    clearTimeout(this.debounceTimeout);
    this.debounceTimeout = setTimeout(() => {
      this.filter.search = value?.trim();
      this.filter.page = 1;
      this.getSegmentList()
    }, 1000);
  }

  sorting(key: string) {
    this.sortingKey = key;
    this.sortingValue = !this.sortingValue ? 'ASC' : (this.sortingValue === 'ASC' ? 'DESC' : 'ASC');
    this.filter.sortKey = this.sortingKey;
    this.filter.sortValue = this.sortingValue;
    this.filter.page = 1;
    this.getSegmentList()
  }

  checkIsErrorMessageValid(error: any) {
    if(typeof error?.error?.message === 'string') {
      return error?.error?.message;
    }
    return 'An unknow error occured';
  }



  fetchUserDataByPage(data: { page: number }) {
    this.filter.page = data.page;
    this.getSegmentList();
  }

  clearFilterDropdown(type: string) {
    const action: Record<string, () => void> = {
      'segment_type': () => this.filter.segment_type = [],
      'status': () => this.filter.status = [],
      'providerElementIds': () => this.filter.providerElementIds = [],
      'partnerIds': () => this.filter.partnerIds = [],
    };
    action[type]()
    this.filter.page = 1;
    this.getSegmentList();
  }

  selectFilterDrowDownItem(data: { checked: boolean }, type: string) {
    const { checked } = data;
    const action: Record<string, () => void> = {
      'segment_type': () => this.filter = {
        ...this.filter,
        segment_type: checked ? this.segmentTypeList : []
      },
      'status': () => this.filter = {
        ...this.filter,
        status: checked ? structuredClone(this.statusList) : []
      },
      'providerElementIds': () => this.filter = {
        ...this.filter,
        providerElementIds: checked ? structuredClone(this.providerElementList) : []
      },
      'partnerIds': () => this.filter = {
        ...this.filter,
        partnerIds: checked ? structuredClone(this.partnerList) : []
      },
    };
    action[type]();
    this.filter.page = 1;
    this.getSegmentList();
  }

  isItemChecked(data: { checked: boolean, item: any }, type: string) {
    const { checked, item } = data;
    const action: Record<string, () => void> = {
      'segment_type': () => checked ? this.filter.segment_type.push(item) : this.filter.segment_type = this.filter.segment_type.filter((child: any) => child.name != item.name),
      'status': () => checked ? this.filter.status.push(item) : this.filter.status = this.filter.status.filter((child: any) => child.name != item.name),
      'providerElementIds': () => checked ? this.filter.providerElementIds.push(item) : this.filter.providerElementIds = this.filter.providerElementIds.filter((child: any) => child.name != item.name),
      'partnerIds': () => checked ? this.filter.partnerIds.push(item) : this.filter.partnerIds = this.filter.partnerIds.filter((child: any) => child.name != item.name),
    };
    action[type]();
    this.filter.page = 1;
    this.getSegmentList();
  }


  clearFilter() {
    this.filter = {
      page: 1,
      limit: 10,
      search: '',
      sortKey: '',
      sortValue: '',
      segment_type:[],
      status:[],
      providerElementIds:[],
      partnerIds:[]
    };

    this.sortingKey = ''
    this.sortingValue = ''
    this.getSegmentList()
  }

  openCreateSegmentModal(): void {
    this._commonService.updateSegmentModal({
      isOpen: true,
      type: 'Create Segment',
    });
  }

  openViewerSegmentModal(segment:any): void {
    this._commonService.updateSegmentModal({
      isOpen: true,
      type: 'Viewer Segment',
      segment_id:segment.segment_id,
      id:segment.id,
      is_rule_based: segment.is_rule_based,
      segment_rule: segment.segment_rule,
    });
  }

  closeSegmentModal(){
    this._commonService.updateSegmentModal({
      isOpen: false,
      type: 'Create Segment'
    });

  }

  reloadSegmentList(){
    this._commonService.updateSegmentModal({ isOpen: false, type: 'Create Segment' });
    this.clearFilter()
  }

  fetchFilter(){
    this._contentMapper.get(segment_endpoint.filter).subscribe({
      next: (response: any) => {
        const {statuses=[],segmentTypes=[],providerElementIds= [],partnerIds=[]} = response.results
        this.statusList = statuses;
        this.segmentTypeList = segmentTypes;
        this.providerElementList = providerElementIds.map((item:any) =>{
          return {
            name:item,
            id:item
          }
        });
        this.partnerList = partnerIds.map((item:any) =>{
          return {
            name:item,
            id:item
          }
        });
      }, error: (error) => {
        this.toastr.error(this.checkIsErrorMessageValid(error));
      }
    })
  }


  getSegmentList(caller:string = ''){
    this.loader = true;
    const {segment_type ,status,page,limit,search,sortKey,sortValue,
      providerElementIds,partnerIds} = this.filter;

    const final_data:any = { 
      segmentTypes:segment_type.map((item:any) => item.id),
      statuses: status.map((item:any) => item.id),
      page,
      limit,
      search,
      sortKey,
      sortOrder: sortValue,
      providerElementIds:providerElementIds.map((item:any) => +item.id),
      partnerIds: partnerIds.map((item:any) => item.id)
    };
    this._contentMapper.post(segment_endpoint.list,final_data).subscribe({
      next: (response: any) => {
        const {totalRecords,segments} =  response.results
        this.totalCount = totalRecords;
        this._commonService.updateSharedData(totalRecords);
        this.segmentList = segments
        this.noData = caller === 'ngOnInit' && this.segmentList.length === 0 ? true : false;
        this.loader = false;
      }, error: (error) => {
        this.toastr.error(this.checkIsErrorMessageValid(error));
        this.loader = false;

      }
    })

  }

  getStatusChipClass(status: string): string {
    const statusMap: Record<string, string> = {
      'archived': 'archived',
      'active': 'active', 
      'inactive': 'inactive',
      'pending': 'pending',
      'deleted': 'deleted',
      'does not exist': 'not-exist',
      'not exist': 'not-exist',
      'does_not_exist': 'not-exist',
      'missing': 'not-exist'
    };
    
    return statusMap[status?.toLowerCase()] || 'inactive';
  }

  getSegmentTypeChipClass(segmentType: string): string {
    const segmentTypeMap: Record<string, string> = {
      'standard': 'standard',
      'custom': 'custom'
    };
    
    return segmentTypeMap[segmentType?.toLowerCase()] || 'standard';
  }


  toggleDropdown(index: number): void {
    this.activeDropdownIndex = this.activeDropdownIndex === index ? -1 : index;
    
  }

  EditSegment(segment:any){
    this.activeDropdownIndex = -1;
    this._contentMapper.get(`${segment_endpoint.segment}/${segment.id}`).subscribe({
      next: (response: any) => {
        const fullSegment = response.results.segment;
        this._commonService.updateSegmentModal({
          isOpen: true,
          type: 'Edit Segment',
          segment_id: fullSegment.segment_id,
          id: fullSegment.id,
          is_rule_based: fullSegment.is_rule_based,
          segment_rule: fullSegment.segment_rule,
        });
      },
      error: (err) => {
        this.toastr.error('Failed to load segment details');
      }
    });
  }

handleSegmentClick(_event: MouseEvent, segment:any) {
  const selection = window.getSelection();
  if (selection && selection.toString().length === 0) {
    this.openViewerSegmentModal(segment);
  }
}


  


}
